export default "__VITE_ASSET__Bkzo6YUP__"